module.exports = __webpack_public_path__ + "img/placeholder.708e3262.png";